import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NCmsHotspots } from './cms-hotspots.interface';

export const hotspotsFields = <D>(canShow: ((data: D) => boolean) | boolean, key = 'hotspots', title = 'Hotspots') => [
    <NICmsContentField.IField>{
        type: NICmsContentField.EFieldType.label,
        key: '_hotspots-content',
        title
    },
    <NICmsContentField.IRepeaterField>{
        key,
        type: NICmsContentField.EFieldType.repeater,
        title,
        itemName: 'hotspot',
        fields: [
            <NICmsContentField.IRelationField>{
                key: 'product',
                type: NICmsContentField.EFieldType.relation,
                title: 'Product',
                multiple: false,
                ordered: true,
                options: {
                    title: 'Product',
                    type: 'product',
                    qty: 1
                }
            },
            {
                key: 'productImage',
                type: NICmsContentField.EFieldType.toggle,
                title: 'Product Image',
                default: true,
            },
            {
                key: 'productPrice',
                type: NICmsContentField.EFieldType.toggle,
                title: 'Product Price',
                default: true,
            },
            {
                key: 'ctaText',
                type: NICmsContentField.EFieldType.text,
                title: 'CTA Text',
                default: 'view'
            },
            {
                key: 'section-position',
                type: NICmsContentField.EFieldType.label,
                title: 'Position'
            },
            <NICmsContentField.INumberField>{
                key: 'top',
                type: NICmsContentField.EFieldType.number,
                title: 'Top',
                required: true,
                default: 50,
                step: 0.1,
                min: 0,
                max: 100,
                description: 'Position from top in %'
            },
            <NICmsContentField.INumberField>{
                key: 'left',
                type: NICmsContentField.EFieldType.number,
                title: 'Left',
                required: true,
                default: 50,
                step: 0.1,
                min: 0,
                max: 100,
                description: 'Position from left in %'
            }
        ],
        canShow: typeof canShow === 'function' ? canShow : () => canShow,
        maxSize: 30,
        default: []
    },
    <NICmsContentField.IChoiceField>{
        key: `${key}Visibility`,
        type: NICmsContentField.EFieldType.choice,
        title: 'Visibility',
        options: [
            { key: NCmsHotspots.EVisibility.Always, title: 'Always' },
            { key: NCmsHotspots.EVisibility.Hover, title: 'On Hover' }
        ],
        default: NCmsHotspots.EVisibility.Always,
        canShow: typeof canShow === 'function' ? canShow : () => canShow
    }
];

export const CMS_HOTSPOTS_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCmsHotspots.ID,
    name: 'Hotspots',
    description: 'Hotspots component',
    tags: ['image', 'hotspots', 'products'],
    isAdvanced: true,
    fields: [
        ...hotspotsFields(true),
        <NICmsContentField.IComponentsField>{
            type: NICmsContentField.EFieldType.components,
            title: 'Components',
            itemName: 'component',
            key: 'components',
            default: []
        }
    ]
};
